import { render, staticRenderFns } from "./authorInfo.vue?vue&type=template&id=71feea42&scoped=true"
import script from "./authorInfo.vue?vue&type=script&lang=ts"
export * from "./authorInfo.vue?vue&type=script&lang=ts"
import style0 from "./authorInfo.vue?vue&type=style&index=0&id=71feea42&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71feea42",
  null
  
)

export default component.exports